/**
 * Storage Service
 * 
 * Abstraction layer for browser storage functionality.
 * This allows the storage implementation to be changed in the future without
 * modifying React components.
 */

import { utils } from "../utils/common";

export const STORAGE_KEYS = {
  USER_ID: 'userId',
  USER_NAME: 'userName',
  USER_AVATAR: 'userAvatar',
  LAST_JOIN_CODE: 'lastJoinCode',

  OLD_PLAYER_ID: 'playerId',
  OLD_PLAYER_NAME: 'playerName',
  OLD_PROFILE_PICTURE: 'profilePicture',
} as const;

export class StorageService {

  public getUserId(): string {
    let result = localStorage.getItem(STORAGE_KEYS.USER_ID) ?? localStorage.getItem(STORAGE_KEYS.OLD_PLAYER_ID);
    if (!result) {
      result = utils.generateGuid();
      this.setUserId(result);
    }
    return result;
  }

  public setUserId(id: string): void {
    localStorage.setItem(STORAGE_KEYS.USER_ID, id);
  }

  public getUserName(): string | null {
    return localStorage.getItem(STORAGE_KEYS.USER_NAME) ?? localStorage.getItem(STORAGE_KEYS.OLD_PLAYER_NAME);
  }

  public setUserName(name: string): void {
    localStorage.setItem(STORAGE_KEYS.USER_NAME, name);
  }

  // public removeUserName(): void {
  //   localStorage.removeItem(STORAGE_KEYS.USER_NAME);
  // }

  public getUserAvatar(): string | null {
    return localStorage.getItem(STORAGE_KEYS.USER_AVATAR) ?? localStorage.getItem(STORAGE_KEYS.OLD_PROFILE_PICTURE);
  }

  public setUserAvatar(dataUrl: string): void {
    localStorage.setItem(STORAGE_KEYS.USER_AVATAR, dataUrl);
  }

  // public removeUserAvatar(): void {
  //   localStorage.removeItem(STORAGE_KEYS.USER_AVATAR);
  // }

  public getJoinCode(): string | null {
    return localStorage.getItem(STORAGE_KEYS.LAST_JOIN_CODE);
  }

  public setJoinCode(joinCode: string): void {
    localStorage.setItem(STORAGE_KEYS.LAST_JOIN_CODE, joinCode);
  }

  public clearAll(): void {
    localStorage.clear();
  }
}

// Export singleton instance
export const storageService = new StorageService();
